"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _productManage = require("@/api/_homeCloudPlatform/mall/productManage.js");
var _config_treatmentplan = require("@/api/config_treatmentplan");
var _commodityClassificationManage = require("@/api/_homeCloudPlatform/mall/commodityClassificationManage.js");
var _articleManage = require("@/api/_homeCloudPlatform/article/articleManage.js");
var _group = require("@/api/_homeCloudPlatform/group/group.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Editor = _interopRequireDefault(require("@/components/Editor"));
var _mixin = _interopRequireDefault(require("./mixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  products: [{
    product: {
      id: ''
    }
  }],
  tags: [],
  category: {
    id: ''
  },
  goods_images: [],
  product_status: 2,
  product_type: 0,
  pkg_type: 1,
  c_plan_photo: null,
  templates: [],
  treated_templates: [],
  goods_type: 2,
  group_type: 2,
  top_b_price: 0,
  b_price: {},
  belong_user: {
    id: ''
  }
};
var formInstock = {
  // quantity: '',
  // note: ''
};
var _default = exports.default = {
  mixins: [_mixin.default],
  components: {
    Pagination: _Pagination.default,
    Editor: _Editor.default
  },
  computed: {
    rules: function rules() {
      var _this = this;
      return {
        name: [{
          required: true,
          message: '请输入商品名称'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        image: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (_this.previewImg.length > 0) {
              callBack();
            } else {
              callBack('请上传图片');
            }
          }
        },
        product_type: {
          required: true,
          message: '请选择商品类型'
        },
        pkg_type: {
          required: true,
          message: '请选择产品包类型'
        },
        // c_plan: { required: true, message: '请选择C端方案' },
        c_plan: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (_this.formModel.pkg_type == "3") {
              callBack();
            } else {
              if (!_this.formModel.c_plan) {
                callBack('请选择C端方案');
              } else {
                callBack();
              }
            }
          }
        },
        c_image: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (_this.previewCPlanImg.image) {
              callBack();
            } else {
              callBack('请上传图片');
            }
          }
        },
        products: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (value) {
              console.log('value:' + JSON.stringify(value));
              var arr = [];
              // 找重复
              _this.formModel.products.forEach(function (item) {
                if (item.product.id + '' && value.product.id === item.product.id) arr.push(item.product.id);
              });
              if (arr.length > 1) {
                callBack('随货产品重复');
              } else if (value.quantity) {
                if (!value.product.id) {
                  callBack('请选择随货产品');
                } else callBack();
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        },
        quantity: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (value) {
              if (value.product.id) {
                if (!value.quantity) callBack('请输入数量');else callBack();
              } else {
                callBack();
              }
            } else {
              callBack();
            }
          }
        },
        category: {
          required: true,
          message: '请选择分类'
        },
        price: {
          required: true,
          message: '请输入售价',
          trigger: 'blur'
        },
        product_content: {
          required: true,
          message: '请输入商品内容',
          trigger: 'change'
        },
        on_shelf_time: {
          required: true,
          validator: function validator(rule, value, callBack) {
            if (_this.on_shelf_time === null || !_this.on_shelf_time[0] || !_this.on_shelf_time[1]) {
              callBack('请选择上架时间');
            } else {
              callBack();
            }
          }
        },
        sort_order: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 > 9999) {
              callBack('输入的数字不应大于9999');
            } else {
              callBack();
            }
          }
        }],
        inStockQuantity: [{
          required: true,
          message: '请输入库存数量'
        }, {
          type: 'number',
          message: '必须为数字值'
        }, {
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 < -10000 || value * 1 > 10000) {
              callBack('请输入正确的库存数量');
            } else {
              callBack();
            }
          }
        }],
        count: [
        // 注意!此写法在切换radio会触发所有必填检查
        // { required: this.formModel.product_type !== 0 ? true : false, message: '请输设备数量', trigger: 'blur'},
        {
          validator: function validator(rule, value, callBack) {
            if (!value && _this.formModel.product_type !== 0) {
              callBack('请输入设备数量');
            } else {
              callBack();
            }
          },
          trigger: 'blur'
        }, {
          type: 'number',
          message: '数量必须为数字值'
        }, {
          type: 'number',
          max: 1000,
          message: '数量不能超过1000'
        }, {
          type: 'number',
          min: 1,
          message: '数量不能少于1'
        }],
        disc_count: [
        // 注意!此写法在切换radio会触发所有必填检查
        // { required: this.formModel.product_type !== 0 ? true : false, message: '请输设备数量', trigger: 'blur'},
        {
          validator: function validator(rule, value, callBack) {
            if (!value && _this.formModel.pkg_type === 3) {
              callBack('请输入盘次数量');
            } else {
              callBack();
            }
          },
          trigger: 'blur'
        }, {
          type: 'number',
          message: '数量必须为数字值'
        }, {
          type: 'number',
          min: 1,
          message: '数量不能少于1'
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '查看';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
        case 'inStock':
          return '库存管理';
      }
      return "".concat(type, "\u5546\u54C1");
    }
  },
  watch: {
    'formModel.pkg_type': {
      immediate: true,
      handler: function handler(val) {
        if (val == 2) {
          this.formModel.product_type = 0;
        }
      }
    },
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    },
    dialogVisible: {
      immediate: true,
      handler: function handler(val) {
        setTimeout(function () {
          // scrollbar置顶
          document.querySelector('.el-dialog__wrapper').scrollTop = 0;
        });
      }
    }
  },
  data: function data() {
    return {
      groupLevelListData: [],
      formModel: formModel,
      formInstock: formInstock,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 默认排序,依创建时间递减
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 10,
        page_size_before: 10,
        product_status: '',
        recommended: '',
        category: '',
        pkg_type: '',
        goods_type: 2,
        //商品類型: 1:C端; 2:B端
        top_b_status: '',
        product_type: '' //商品類型：0:調理包; 2:設備
      },
      dialogVisible: false,
      dialogType: 'view',
      // 状态选项
      pkg_typeOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '到家产品包'
      }, {
        key: 2,
        display_name: '到店产品包'
      }, {
        key: 3,
        display_name: '机构产品包'
      }],
      // 状态选项
      statusOptions: [{
        key: 0,
        display_name: '全部'
      }, {
        key: 1,
        display_name: '上架'
      }, {
        key: 2,
        display_name: '下架'
      }],
      // 推荐商品选项
      recommendedProductOptions: [{
        key: 0,
        value: 'all',
        display_name: '全部'
      }, {
        key: 1,
        value: true,
        display_name: '推荐商品'
      }, {
        key: 2,
        value: false,
        display_name: '非推荐商品'
      }],
      // 随货产品清单
      productlist: [],
      // 到家C端方案
      cEndSolutionOptions: [],
      // 到店C端方案
      cEndToShopSolutionOptions: [],
      // 分类
      classificationOptions: [],
      // 库存
      stocksListQuery: {
        page: 1,
        page_size: 10,
        page_size_before: 10
      },
      stocksData: [],
      inputVisible: false,
      inputValue: '',
      previewImg: [],
      on_shelf_time: null,
      tagsList: [],
      deleteImgArr: [],
      previewCPlanImg: {},
      templateList: [],
      ordersCount: 0,
      //搜寻商品是否有被下单过返回订单数量,
      groupTopBListData: []
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
    this.getProductList();
    this.getClassificationList();
    this.getcEndSolutionList();
    this.getcEndToShopSolutionList();
    this.getTagsList();
    this.getTemplateList();
    this.getGroupList();
    this.getGroupLevelList();
  },
  methods: {
    validateNumber: function validateNumber(rule, value, callback) {
      var number = Number(value);
      if (number < 0 || number > 100) {
        callback(new Error('请输入 0 到 100 的数字'));
      } else {
        callback();
      }
    },
    checkPermission: _permission.default,
    // c端方案清单
    getcEndSolutionList: function getcEndSolutionList() {
      var _this2 = this;
      (0, _config_treatmentplan.getTreatmentPlanList)({
        page: 1,
        page_size: 1
      }).then(function (data) {
        if (!data.data.count) return;
        (0, _config_treatmentplan.getTreatmentPlanList)({
          page_size: data.data.count,
          support_go_home: true,
          status: 1
        }).then(function (res) {
          _this2.cEndSolutionOptions = res.data.results || [];
        });
      });
    },
    getcEndToShopSolutionList: function getcEndToShopSolutionList() {
      var _this3 = this;
      (0, _config_treatmentplan.getTreatmentPlanList)({
        page: 1,
        page_size: 1
      }).then(function (data) {
        if (!data.data.count) return;
        (0, _config_treatmentplan.getTreatmentPlanList)({
          page_size: data.data.count,
          support_go_home: true
        }).then(function (res) {
          _this3.cEndToShopSolutionOptions = res.data.results || [];
        });
      });
    },
    // 随货产品清单
    getProductList: function getProductList() {
      var _this4 = this;
      (0, _productManage.getProductList)({
        product_status: 1
      }).then(function (res) {
        _this4.productlist = res.results || [];
      });
    },
    // 分类清单
    getClassificationList: function getClassificationList() {
      var _this5 = this;
      (0, _commodityClassificationManage.getGoodscategoryList)().then(function (res) {
        _this5.classificationOptions = res.results || {};
      });
    },
    // 标籤清单
    getTagsList: function getTagsList() {
      var _this6 = this;
      (0, _commodityManage.getTagsList)().then(function (response) {
        _this6.tagsList = response.results.filter(function (item) {
          return item.type === 0;
        }) || [];
      });
    },
    // 模板清单
    getTemplateList: function getTemplateList() {
      var _this7 = this;
      (0, _articleManage.getTemplate)().then(function (res) {
        _this7.templateList = res.results || {};
      });
    },
    //搜寻商品是否有被下单过
    getOrdersCountbyGoodsId: function () {
      var _getOrdersCountbyGoodsId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(id) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _commodityManage.getOrdersCountbyGoodsId)({
                goods_id: id
              });
            case 2:
              res = _context.sent;
              this.ordersCount = res.count || 0;
              console.log('getOrdersCountbyGoodsId res', res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOrdersCountbyGoodsId(_x) {
        return _getOrdersCountbyGoodsId2.apply(this, arguments);
      }
      return getOrdersCountbyGoodsId;
    }(),
    getList: function getList(e) {
      var _this8 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _commodityManage.getGoodsList)(this.handleQuery()).then(function (res) {
        _this8.tableData = res || {};
        _this8.listLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      var _this9 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this9.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this10 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this10.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this11 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row)); // copy obj
      this.handleInitData();
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this11.$refs['Form'].clearValidate();
      });
    },
    handleInStock: function handleInStock(scope) {
      var _this12 = this;
      this.stocksListQuery = {
        page: 1,
        page_size: 10
      };
      this.formModel = JSON.parse(JSON.stringify({
        goods: scope.row.id
      }));
      this.getStocksList();
      this.dialogType = 'inStock';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this12.$refs['Form'].clearValidate();
      });
    },
    getStocksList: function getStocksList(e) {
      var _this13 = this;
      this.listLoading = true;
      if (e && this.stocksListQuery.page_size_before != e.limit) {
        this.stocksListQuery.page = 1;
        this.stocksListQuery.page_size_before = e.limit;
      }
      (0, _commodityManage.getStocksList)({
        page: this.stocksListQuery.page,
        page_size: this.stocksListQuery.page_size,
        goods: this.formModel.goods
      }).then(function (res) {
        _this13.stocksData = res || [];
        _this13.listLoading = false;
      });
    },
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(scope) {
        var _this14 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getOrdersCountbyGoodsId(scope.row.id);
            case 2:
              console.log('ordersCount', this.ordersCount);
              if (this.ordersCount > 0) {
                //商品有被下单无法删除
                this.$alert('商品曾被下单无法被删除', '警告', {
                  confirmButtonText: '确认',
                  type: 'warning'
                });
              } else {
                //商品查无订单确认删除
                this.$confirm('确认删除?', '警告', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'error'
                }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return (0, _commodityManage.deleteGoods)(scope.row.id);
                      case 2:
                        _this14.getList();
                        _this14.$message({
                          type: 'success',
                          message: '成功删除!'
                        });
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }))).catch(function () {
                  return;
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this15 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // console.log("DDDD:"+JSON.stringify(this.formModel))
              // return false
              this.$refs[form].validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(valid) {
                  var isEdit, commonMethod, checkbPriceResult, check_bPrice;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!valid) {
                          _context4.next = 15;
                          break;
                        }
                        _context4.next = 3;
                        return _this15.deleteGoodsImage();
                      case 3:
                        isEdit = _this15.dialogType === 'edit';
                        commonMethod = function commonMethod(title) {
                          _this15.getList();
                          _this15.dialogVisible = false;
                          _this15.$message({
                            message: "".concat(title, "\u6210\u529F"),
                            type: 'success'
                          });
                        };
                        checkbPriceResult = true;
                        if (_this15.formModel.group_type == 2) {
                          //B端合作伙伴伴
                          // check bprice
                          check_bPrice = _this15.transformData(_this15.formModel.b_price);
                          checkbPriceResult = _this15.checkStringStructure(check_bPrice);
                        }
                        if (checkbPriceResult) {
                          _context4.next = 12;
                          break;
                        }
                        _this15.$message({
                          message: '请确认B端合作伙伴产品包售价',
                          type: 'warning'
                        });
                        return _context4.abrupt("return", false);
                      case 12:
                        if (isEdit) {
                          // let checkbPriceResult = true
                          // if (this.formModel.group_type==2) {
                          //   // check bprice
                          //   let check_bPrice = this.transformData(this.formModel.b_price)            
                          //   checkbPriceResult = this.checkStringStructure(check_bPrice);
                          // }

                          (0, _commodityManage.updateGoods)(_this15.formModel.id, _this15.handleFormData()).then(function (res) {
                            if (res.status_code !== 200) {
                              return _this15.errorHandle(res);
                            }
                            commonMethod('编辑');
                          });
                        } else if (_this15.dialogType === 'add') {
                          // check bprice

                          (0, _commodityManage.createGoods)(_this15.handleFormData()).then(function (res) {
                            if (res.status_code !== 200) {
                              return _this15.errorHandle(res);
                            }
                            commonMethod('新增');
                          });
                        } else if (_this15.dialogType === 'inStock') {
                          (0, _commodityManage.createStocks)((0, _objectSpread2.default)({}, _this15.formModel)).then(function (res) {
                            if (res.status_code !== 200) {
                              return _this15.errorHandle(res);
                            }
                            commonMethod('编辑');
                          });
                        }
                      case 13:
                        _context4.next = 17;
                        break;
                      case 15:
                        _this15.scrollToBlankInput();
                        return _context4.abrupt("return", false);
                      case 17:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirm(_x3) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    scrollToBlankInput: function () {
      var _scrollToBlankInput = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              //预防在警告提示生成前执行完毕
              setTimeout(function () {
                var blankElement = document.getElementsByClassName('el-form-item__error');
                var elementTop = blankElement[0];
                var elementTopParent = elementTop.closest('.el-row');
                var dialogWrapper = document.querySelector('.el-dialog__wrapper');
                dialogWrapper.scrollTo({
                  top: elementTopParent.offsetTop,
                  behavior: "smooth"
                });
              }, 330);
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function scrollToBlankInput() {
        return _scrollToBlankInput.apply(this, arguments);
      }
      return scrollToBlankInput;
    }(),
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this16 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this16.previewImg.push({
            image: e.target.result,
            file: file
          });
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeImg: function removeImg(item) {
      this.previewImg.splice(this.previewImg.indexOf(item), 1);
      if (Object.prototype.hasOwnProperty.call(item, "id")) this.deleteImgArr.push(item.id);
    },
    // 初始化资料处理
    handleInitData: function handleInitData() {
      var _this17 = this;
      this.deleteImgArr = [];
      this.previewImg = [];
      // this.formModel.templatesID = []
      // 商品图
      if (this.formModel.goods_images.length > 0) {
        this.formModel.goods_images.forEach(function (item) {
          _this17.previewImg.push({
            image: item.image,
            id: item.id
          });
        });
      }
      // 随货产品
      if (this.formModel.products.length == 0) {
        this.formModel.products.push({
          product: {
            id: ''
          }
        });
      }
      // Tags
      if (this.formModel.tags.length > 0) {
        var arr = [];
        this.formModel.tags.forEach(function (item) {
          arr.push(item.name);
        });
        this.formModel.tags = arr;
      }
      // 上架时间
      this.on_shelf_time = [this.formModel.on_shelf_start || '', this.formModel.on_shelf_end || ''];
      // c端方案图片
      this.previewCPlanImg = {
        image: this.formModel.c_plan_photo
      };
      if (this.formModel.templates.length > 0) {
        var templateArr = [];
        this.formModel.templates.forEach(function (item) {
          templateArr.push(item.id);
        });
        this.formModel.templates = templateArr;
      }
      if (this.formModel.treated_templates && this.formModel.treated_templates.length > 0) {
        var _templateArr = [];
        this.formModel.treated_templates.forEach(function (item) {
          _templateArr.push(item.id);
        });
        this.formModel.treated_templates = _templateArr;
      } else {
        this.formModel.treated_templates = [];
      }
      if (this.formModel.belong_user == null) {
        this.formModel.belong_user = {
          id: ''
        };
      }
      // Tags
      if (this.formModel.top_b_status) {
        this.formModel.group_type = 1; //大客戶
      } else {
        this.formModel.group_type = 2; //B端合作伙伴
        var reversedData = this.reverseTransformData(this.formModel.b_price);
        this.formModel.b_price = JSON.parse(JSON.stringify(reversedData));
      }
    },
    // --- 随货产品 start ---
    addIncludedProduct: function addIncludedProduct() {
      this.formModel.products.push({
        product: {
          id: ''
        }
      });
    },
    deleteIncludedProduct: function deleteIncludedProduct(item) {
      var _this18 = this;
      this.formModel.products.splice(this.formModel.products.indexOf(item), 1);
      this.$nextTick(function () {
        // this.$refs['Form'].clearValidate()
        _this18.formModel.products.forEach(function (item, index) {
          _this18.$refs['Form'].validateField("products.".concat(index));
        });
      });
    },
    // --- 随货产品 end ---
    // --- tag start ---
    showInput: function showInput() {
      var _this19 = this;
      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this19.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        var obj = {
          name: inputValue
        };
        if (!this.tagsList.filter(function (item) {
          return item.name === inputValue;
        }).length) {
          this.tagsList.push(obj);
          this.formModel.tags.push(inputValue);
          this.inputVisible = false;
          this.inputValue = '';
        } else {
          this.$message({
            message: '标签已存在',
            type: 'warning'
          });
        }
      }
    },
    // --- tag end ---
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering,
        goods_type: 2,
        top_b_status: '',
        product_type: ''
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.product_status === '' || query.product_status === 0) {
        query.product_status = function () {
          return;
        }();
      }
      // 推荐商品参数处理
      if (query.recommended === '' || query.recommended === 'all') {
        query.recommended = function () {
          return;
        }();
      }
      // 分类
      if (query.category === '' || query.category === 'all') {
        query.category = function () {
          return;
        }();
      }
      // 产品包
      if (query.pkg_type === '' || query.pkg_type === 'all') {
        query.pkg_type = function () {
          return;
        }();
      }
      // 商品类型
      if (query.product_type === '' || query.product_type === 'all') {
        query.product_type = function () {
          return;
        }();
      }
      // 合作伙伴类型
      if (query.top_b_status === '' || query.top_b_status === 'all') {
        query.top_b_status = function () {
          return;
        }();
      } else if (query.top_b_status == '1') {
        query.top_b_status = true;
      } else {
        query.top_b_status = false;
      }
      return query;
    },
    // submit Data
    handleFormData: function handleFormData() {
      var _this20 = this;
      var formdata = new FormData();
      if (this.on_shelf_time) {
        this.formModel.on_shelf_start = this.on_shelf_time[0];
        this.formModel.on_shelf_end = this.on_shelf_time[1];
      }

      // FormData object / array格式处理
      var _loop = function _loop(key) {
        var arr = [];
        switch (key) {
          case 'products':
            _this20.formModel.products.forEach(function (item, index) {
              if (item.product.id) arr.push({
                product: item.product.id,
                quantity: item.quantity
              });
            });
            formdata.append(key, JSON.stringify(arr));
            break;
          case 'tags':
            _this20.formModel.tags.forEach(function (item, index) {
              arr.push({
                name: item
              });
            });
            formdata.append(key, JSON.stringify(arr));
            break;
          case 'templates':
            _this20.formModel.templates.forEach(function (item, index) {
              arr.push(item);
            });
            formdata.append(key, JSON.stringify(arr));
            break;
          case 'treated_templates':
            _this20.formModel.treated_templates.forEach(function (item, index) {
              arr.push(item);
            });
            formdata.append(key, JSON.stringify(arr));
            break;
          case 'category':
            formdata.append(key, _this20.formModel.category.id);
            break;
          case 'goods_images':
            _this20.previewImg.forEach(function (item, index) {
              if (item.file) {
                formdata.append(key, item.file);
              }
            });
            break;
          case 'c_plan_photo':
            if (_this20.previewCPlanImg.file) {
              _this20.formModel.c_plan_photo = _this20.previewCPlanImg.file;
            }
            if (!_this20.previewCPlanImg.image) {
              _this20.formModel.c_plan_photo = '';
            }
            formdata.append(key, _this20.formModel[key]);
            break;
          case 'product_content':
            _this20.formModel[key] = _this20.$refs.editor.handlehtml(_this20.formModel[key]);
            formdata.append(key, _this20.formModel[key]);
            break;
          case 'count':
            if (_this20.formModel.product_type !== 0) {
              formdata.append(key, _this20.formModel.count);
            }
            break;
          case "group_type":
            if (_this20.formModel.group_type === 1) {
              //大客戶
              _this20.formModel.top_b_status = true;
              if (!formdata.has("top_b_status")) {
                formdata.append("top_b_status", true);
              }
              // this.formModel.top_b_price = true
              // formdata.append("top_b_price", this.formModel.top_b_price)
              // formdata.append("belong_user", this.formModel.belong_user)
            } else {
              _this20.formModel.top_b_status = false;
              if (!formdata.has("top_b_status")) {
                formdata.append("top_b_status", false);
              }
              // formdata.delete('b_price');
              // let b_price = this.transformData(this.formModel.b_price)
              // formdata.append("b_price", b_price)
            }
            break;
          case "b_price":
            if (_this20.formModel.group_type === 1) {//大客戶
            } else {
              var b_price = _this20.transformData(_this20.formModel.b_price);
              formdata.append("b_price", b_price);
            }
            break;
          case "top_b_price":
            if (_this20.formModel.group_type === 1) {
              //大客戶
              formdata.append("top_b_price", _this20.formModel.top_b_price);
            } else {}
            break;
          case 'sales_user':
            formdata.delete("sales_user");
            break;
          case 'price':
            formdata.delete("price");
            break;
          // case 'top_b_status':
          //   delete formdata.top_b_status
          // break;           
          case 'belong_user':
            if (_this20.formModel.group_type === 1 && (_this20.dialogType === 'add' || _this20.dialogType === 'edit')) {
              //新增大客戶
              if (_this20.formModel.belong_user) {
                console.log('dddd');
                formdata.append("belong_user", _this20.formModel.belong_user.id);
              }
            } else {
              //其他操作都不變更belong_user
              formdata.delete("belong_user");
            }
            break;
          case 'c_plan':
            if (_this20.formModel.pkg_type === 3) {
              // formdata.delete("c_plan");
              // formdata.append("c_plan", 5) //暫時指定為方案5 感冒咳嗽治疗方案
            } else {
              formdata.append("c_plan", _this20.formModel.c_plan);
            }
            break;
          case 'disc_count':
            if (_this20.formModel.pkg_type === 3) {
              formdata.append("disc_count", _this20.formModel.disc_count);
              // formdata.append("c_plan", 5) //暫時指定為方案5 感冒咳嗽治疗方案        
            } else {
              formdata.delete("disc_count");
            }
            break;
          default:
            if (!formdata.has(key)) {
              formdata.append(key, _this20.formModel[key]);
            }
        }
      };
      for (var key in this.formModel) {
        _loop(key);
      }
      // remove B端商品參數
      // sales_user
      // b_price
      // top_b_status
      // belong_user
      // top_b_price
      // bPrice
      return formdata;
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // 移除商品图片
    deleteGoodsImage: function () {
      var _deleteGoodsImage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        var _this21 = this;
        var _iterator, _step, id;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _iterator = (0, _createForOfIteratorHelper2.default)(this.deleteImgArr);
              _context7.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context7.next = 9;
                break;
              }
              id = _step.value;
              _context7.next = 7;
              return (0, _commodityManage.deleteGoodsImage)(id).then(function (res) {
                if (res.status_code !== 200) {
                  return _this21.errorHandle(res);
                }
              });
            case 7:
              _context7.next = 3;
              break;
            case 9:
              _context7.next = 14;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](1);
              _iterator.e(_context7.t0);
            case 14:
              _context7.prev = 14;
              _iterator.f();
              return _context7.finish(14);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 11, 14, 17]]);
      }));
      function deleteGoodsImage() {
        return _deleteGoodsImage2.apply(this, arguments);
      }
      return deleteGoodsImage;
    }(),
    // c端方案图片预览
    cPlanBeforeAvatarUpload: function cPlanBeforeAvatarUpload(file) {
      var _this22 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this22.previewCPlanImg = {
            image: e.target.result,
            file: file
          };
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeCPlanImg: function removeCPlanImg() {
      this.previewCPlanImg = {};
    },
    handleDeviceTypeDisabled: function handleDeviceTypeDisabled() {
      var isDisabled = true;
      // 非查看,且产品包类型不是到店产品包，可编辑
      if (!this.disabled && this.formModel.pkg_type !== 2) {
        isDisabled = false;
      }
      return isDisabled;
    },
    getGroupList: function getGroupList() {
      var _this23 = this;
      (0, _group.getGroupList)({
        page_size: 10000,
        top_b_status: true,
        group_status: 1
      }).then(function (response) {
        if (response.results) {
          _this23.groupTopBListData = response.results || [];
        }
      });
    },
    getGroupLevelList: function getGroupLevelList() {
      var _this24 = this;
      (0, _group.getGroupLevelList)({
        page: 1,
        page_size: 1,
        group_level_status: 1
      }).then(function (data) {
        if (!data.count) return;
        (0, _group.getGroupLevelList)({
          page_size: data.count,
          group_level_status: 1
        }).then(function (res) {
          _this24.groupLevelListData = res.results || [];
          // console.log('groupLevelOptions',this.groupLevelListData)
        });
      });
    },
    transformData: function transformData(inputData) {
      var result = {};
      Object.keys(inputData).forEach(function (key) {
        var price = parseFloat(inputData[key]).toFixed(2);
        result[key] = {
          price: price
        };
      });
      return JSON.stringify(result);
    },
    reverseTransformData: function reverseTransformData(inputData) {
      var result = {
        "b_price": {}
      };
      Object.keys(inputData).forEach(function (key) {
        result.b_price[key] = inputData[key].price;
      });
      return result.b_price;
    },
    checkStringStructure: function checkStringStructure(inputString) {
      try {
        var parsedObject = JSON.parse(inputString);
        var expectedKeys = [];
        if (this.groupLevelListData.length > 0) {
          this.groupLevelListData.forEach(function (element) {
            expectedKeys.push(element.group_level);
          });
        }
        console.log('DD:' + JSON.stringify(expectedKeys));

        // const expectedKeys = ["level_1", "level_2", "level_3", "level_4", "level_5"];

        for (var _i = 0, _expectedKeys = expectedKeys; _i < _expectedKeys.length; _i++) {
          var key = _expectedKeys[_i];
          if (parsedObject.hasOwnProperty(key) && parsedObject[key].hasOwnProperty('price') && parsedObject[key].price > 0) {
            continue;
          } else {
            return false;
          }
        }
        return true;
      } catch (error) {
        console.error('Error parsing the input string:', error);
        return false;
      }
    }
  }
};